export const QUERY_KEYS = {
  FAVORITES: "favorites",
};